import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import logoLight from '../assets/logo-light.svg';
import heroBg from '../assets/hero-bg.svg';
import HeroSlider from './HeroSlider';

export default function HomeHero() {
  // Use the slider for a dynamic hero similar to the demo
  return <HeroSlider />;
}
